import React, { useEffect, useMemo, useState } from 'react'
import { safeHTML } from '../../../../utils/safeHTML'
import { useRequestsHandlerData } from '../../../../hooks/useRequestsHandlerData'
import { useRequests } from '../../../../redux/reducer/requests'
import { useExtraProfile } from '../../../../hooks/useExtraProfile'
import AppLoader from '../../../features/appLoader/AppLoader'
import Back from '../../../features/back/Back'
import useStateControls from '../../../../hooks/useStateControls'
import classNames from 'classnames'
import { RatingItems } from '../../../features/rating'
import { useTranslation } from '../../../../translations'

const WEEK_RATING_COUNT = 100
const MONTH_RATING_COUNT = 100

const OldRating = React.forwardRef(function OldRating(ratingData, ref) {
  const { callbacks, title, text, state, ratingPromises, className, week, month, months } =
    ratingData
  const {
    authData: { isWeb },
  } = useRequests()
  const isPending = useExtraProfile()
  const [rating, setRating] = useState({
    ratingMonth: {},
    ratingWeek: [],
    ratingUserMonth: [],
    ratingUserWeek: [],
  })
  const { setState } = useStateControls()
  const { t } = useTranslation()
  const activeRange = 'week'

  useEffect(() => {
    callbacks.getOldWeekRating?.()
  }, [])
  useRequestsHandlerData([
    //исторический месячный рейтинг
    {
      address: 'requestsGameOldWeekRating',
      fulfilled: (response) => {
        const { rating_month } = response || {}
        setRating((prev) => ({
          ...prev,
          ratingMonth: rating_month,
        }))
      },
    },
  ])

  const isRatingPending = useRequestsHandlerData([
    ...ratingPromises.map(({ address, field, key }) => ({
      address,
      fulfilled: (data) => {
        if (!Array.isArray(field)) {
          setRating((prev) => ({ ...prev, [key]: data[field] }))
          return
        }
        setRating((prev) => ({
          ...prev,
          [key]: field.reduce((acc, item) => ({ ...acc, [item]: data[item] }), {}),
        }))
      },
    })),
  ])

  const ratingInfo = useMemo(() => {
    const { ratingWeek, ratingUserMonth, ratingUserWeek, ratingMonth } = rating

    const weekBoards = Array.isArray(ratingWeek)
      ? ratingWeek.map((weekItem) => ({
          title: `${weekItem.season_date.start_at} - ${weekItem.season_date.end_at}`,
          rating: weekItem.players,
        }))
      : []

    const monthBoards = Object.entries(ratingMonth || {})

    return {
      month: {
        user: ratingUserMonth,
        rating: monthBoards,
        date: month,
        limit: MONTH_RATING_COUNT,
      },
      week: {
        user: ratingUserWeek,
        rating: weekBoards,
        limit: WEEK_RATING_COUNT,
      },
    }
  }, [rating, month])

  const renderWeekBoards = () => {
    return ratingInfo.week.rating.map((weekBoard, idx) => (
      <div
        className='rating__blocks'
        key={idx}
      >
        <div className='rating__title-old-rating'>{weekBoard.title}</div>
        <RatingItems
          hideUserInfo={true}
          ratingInfo={{
            activeRatings: {
              rating: weekBoard.rating,
              user: ratingInfo.week.user,
              limit: WEEK_RATING_COUNT,
            },
          }}
          isPending={isPending}
          mod={weekBoard?.rating.length < 5 ? 'noScroll' : ``}
          callbacks={callbacks}
          ratingCount={WEEK_RATING_COUNT}
        />
      </div>
    ))
  }

  const renderMonthBoard = () => {
    if (!ratingInfo.month.rating || ratingInfo.month.rating.length === 0) {
      return <></>
    }
    return ratingInfo.month.rating.map(([monthNum, users]) => {
      return (
        <div
          className='rating__blocks'
          key={monthNum}
        >
          <div className='rating__title-old-rating'>{t(months[monthNum])}</div>
          <RatingItems
            ratingInfo={{
              activeRatings: {
                rating: users,
                user: ratingInfo.month.user,
                limit: MONTH_RATING_COUNT,
              },
            }}
            mod={users.length < 8 ? 'noScroll' : ''}
            ratingCount={MONTH_RATING_COUNT}
            isPending={isPending}
          />
        </div>
      )
    })
  }
  /* <div className="rating__blocks">
        <div className="rating__title-old-rating">{safeHTML(ratingInfo.month.date)}</div>
        <RatingItems
          hideUserInfo={true}
          ratingInfo={{
            activeRatings: {
              rating: ratingInfo.month.rating,
              user: ratingInfo.month.user,
              limit: MONTH_RATING_COUNT,
            },
          }}
          callbacks={callbacks}
          ratingCount={MONTH_RATING_COUNT}
        />
      </div> */

  return (
    <section
      className={classNames(
        'rating',
        `rating_${activeRange} rating_fullScroll`,
        className,
        isWeb ? '' : 'app',
      )}
      ref={ref}
    >
      <Back onClick={() => setState('rating')} />

      <div className={`rating__content`}>
        <h2 className={'rating__title'}>{safeHTML(t(title))}</h2>
        <p className={'rating__text'}>{safeHTML(t(text))}</p>
        <div className={'rating__list'}>{renderWeekBoards()}</div>
      </div>
      {(isPending || isRatingPending) && <AppLoader />}
    </section>
  )
})

export default OldRating
OldRating.propTypes = {}
